/**this is so fucking stupid fuck this stupid elitist bourgeosie asian stereotype performative male and his stupid fucking entitlement i hope this button doesn't deserve to exist */

import React from 'react';
import './ChiefProgramMentor.css';
import { Link } from 'react-router-dom';

const ChiefProgramMentor = () => {
    return (
        <div className="cpm">
            <div className="cpm_title_container">
                <div className="cpm_title">
                    Chief Program Mentor
                </div>
            </div>
            <div className="cpm_content_container">
            <div className="cpm_container1">
                <div className="cpm_photo">
                    <img src="https://firebasestorage.googleapis.com/v0/b/internationalbuddy2018.appspot.com/o/our_team%2F2025%20leaders%2Fneo%20hou.jpg?alt=media&token=fc256cb9-9f9e-44a9-8821-928926612e25" alt="self" />
                </div>
                <div className="cpm_content">
                    <div className="cpm_name">
                    Neo Hou
                    </div>
                    <div className="cpm_selfintro">
                    Hi, my name is Neo Hou, and I’m a rising junior at Harvard University. As a founding member of IB, I’ve had the opportunity to not only volunteer and develop relationships with my peers but also watch the organization grow. IB has been one of my most rewarding experiences, and I am excited to serve as a senior advisor. In this role, I am dedicated to providing training and guidance to new volunteer-buddy pairs and activities, contributing to the organization’s growth and commitment to empowering neurodivergent children.
                    </div>
                </div>
            </div>

        </div>
        </div>
    )
}

export default ChiefProgramMentor